export const isGovSite = (): boolean => {
    return window.location.hostname.includes('gov');
};
